import { z } from "zod";
import { Chain } from "./enums/chain";
import { TokenSchema } from "./pool";

export const ChainSchema = z.object({
  id: z.enum(Chain),
  name: z.string(),
  native_token: TokenSchema.optional(),
  wrapped_token: TokenSchema.optional(),
  quote_tokens: z.array(TokenSchema),
  color: z.string(),
  platform_fee: z.number().default(0.005), //todo
  gas_fee: z.number().default(0.000005), //todo
});

export type IChain = z.infer<typeof ChainSchema>;
